<template>
  <div class="table_one_warp">
    <el-table :cell-style="getRowClass" :header-cell-style="getRowClass" max-height="250" :data="reverseTableData"
      style="width: 100%">
      <el-table-column width="180px" align="center" label="时间" prop="logtime" />
      <el-table-column width="100px" align="center" label="记录人" prop="username">
        <template slot-scope="props">
          {{ allSelect.TEXTUSERS[props.row.username] }}
        </template>
      </el-table-column>
      <el-table-column label="内容" prop="content">
        <template slot-scope="props">
          <div v-html="props.row.content"></div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      allSelect: (state) => state.devOps.ALLSELECT,
    }),
    reverseTableData: function () {
      let tableData = []
      this.tableData.forEach((item) => {
        const actionRecord = item.output?.actionRecord || [];
        let { record = '', username = '' } = actionRecord[0] || {};
        const content = record.replace(/<p>/g, '<p style="margin:0;">')
        if (actionRecord.length) {
          tableData.unshift({
            logtime: item.logtime,
            username,
            content
          })
        };
      })
      return tableData;
    },
  },
  mounted() {
    console.log(this.tableData);
  },
  methods: {
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background:#f1fbec";
    },
  },
};
</script>
<style lang="scss" scoped>
.table_one_warp {
  background: #f1fbec;
}

.table_onde_warp_content {
  white-space: pre-wrap;
}
</style>

<style  lang="scss">
.table_one_warp {

  .el-table__body-wrapper {
    scrollbar-width: thin;
    scrollbar-color: skyblue #eee;
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent);
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }
}
</style>